import {NgModule} from '@angular/core';
import {EtlComponent} from './etl/etl.component';
import {EtlUpdateComponent} from './etl-update/etl-update.component';
import {EtlUpdateSetupComponent} from './etl-update/etl-update-setup/etl-update-setup.component';
import {
    SelectorFieldTableComponent
} from './etl-update/etl-update-design2/selector-field-table/selector-field-table.component';
import {EtlUpdateFilterComponent} from './etl-update/etl-update-filter/etl-update-filter.component';
import {EtlUpdateProcessComponent} from './etl-update/etl-update-process/etl-update-process.component';
import {FilterEtlComponent} from './etl-update/etl-update-filter/filter-etl/filter-etl.component';
import {GroupEtlComponent} from './etl-update/etl-update-filter/group-etl/group-etl.component';

import {EtlUpdateDesign2Component} from './etl-update/etl-update-design2/etl-update-design2.component';
import {
    EtlPopupDesignParamComponent
} from './etl-update/etl-update-design2/etl-popup-design-param/etl-popup-design-param.component';
import {
    EtlPopupDesignStaticParamComponent
} from './etl-update/etl-update-design2/etl-popup-design-static-param/etl-popup-design-static-param.component';
import {
    EtlPopupDesignSelectTableGroupageComponent
} from './etl-update/etl-update-design2/etl-popup-design-select-table-groupage/etl-popup-design-select-table-groupage.component';
import {EtlTaskPreviewComponent} from './etl-task-preview/etl-task-preview.component';
import {TasksService} from '../../components/tasks/tasks.service';
import {EtlTaskComponent} from './etl-task/etl-task.component';
import {ComponentsModule} from '../../components/components.module';
import {
    EtlPopupDesignScriptsComponent
} from './etl-update/etl-update-design2/etl-popup-design-scripts/etl-popup-design-scripts.component';
import {ListColEtlComponent} from './etl-update/etl-update-filter/list-col-etl/list-col-etl.component';
import {
    SimpleListColEtlComponent
} from './etl-update/etl-update-filter/simple-list-col-etl/simple-list-col-etl.component';
import {SelectCampaignComponent} from './etl-update/etl-update-filter/select-campaign/select-campaign.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {StepsModule} from 'primeng/steps';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {DatePickerModule} from 'primeng/datepicker';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ChipsModule} from 'primeng/chips';
import {FieldsetModule} from 'primeng/fieldset';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DialogModule} from 'primeng/dialog';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {TabViewModule} from 'primeng/tabview';
import {TabsModule} from 'primeng/tabs';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {PanelModule} from 'primeng/panel';
import {ListboxModule} from 'primeng/listbox';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TooltipModule} from 'primeng/tooltip';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {KeyFilterModule} from 'primeng/keyfilter';
import {MultiSelectModule} from 'primeng/multiselect';
import {CheckboxModule} from 'primeng/checkbox';
import {SplitButtonModule} from 'primeng/splitbutton';
import {TextareaModule} from 'primeng/textarea';
import {ToastModule} from 'primeng/toast';
import {RadioButtonModule} from 'primeng/radiobutton';
import {AccordionModule} from 'primeng/accordion';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {TableModule} from 'primeng/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {
    TableListHierarchyComponent
} from './etl-update/etl-update-setup/table-list-hierarchy/table-list-hierarchy.component';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';
import {EtlDictionnaryModule} from './etl-dictionnary/etl-dictionnary.module';
import {FileUploadModule} from 'primeng/fileupload';
import {MenuModule} from 'primeng/menu';
import {EtlScriptUpdateComponent} from './etl-script-update/etl-script-update.component';
import {SelectGroovyScriptComponent} from '../../components/select-groovy-script/select-groovy-script.component';
import {EtlExportUpdateComponent} from './etl-export-update/etl-export-update.component';
import {
    EtlExportUpdateDescriptionComponent
} from './etl-export-update/etl-export-update-description/etl-export-update-description.component';
import {
    EtlExportUpdateSearchComponent
} from './etl-export-update/etl-export-update-search/etl-export-update-search.component';
import {
    EtlExportUpdateParamComponent
} from './etl-export-update/etl-export-update-param/etl-export-update-param.component';
import {PasswordModule} from 'primeng/password';
import {InputTextModule} from 'primeng/inputtext';
import {InputGroupModule} from 'primeng/inputgroup';
import {FileServerConfigComponent} from '../../components/file-server-config/file-server-config.component';
import {BeautifulFilterComponent} from '../../components/filter/beautiful-filter/beautiful-filter.component';
import {ImportStepsComponent} from '../../components/import-steps/import-steps.component';
// const ENTITY_STATES = [...etlRoute];
import {TableDataModule} from '../../components/table-data/table-data.module';
import {SelectEtlsComponent} from "../../components/select-etls/select-etls.component";
import { PipesModule } from '../../pipes/pipes.module';
import { ProgressBarModule } from 'primeng/progressbar';
import {EtlI18nConversionComponent} from './etl-update/etl-update-design2/etl-i18n-conversion/etl-i18n-conversion.component';

const cmp = [EtlComponent, EtlUpdateComponent, EtlUpdateSetupComponent,
    SelectorFieldTableComponent,
    EtlUpdateFilterComponent,
    EtlUpdateProcessComponent,
    FilterEtlComponent,
    GroupEtlComponent,
    EtlUpdateDesign2Component,
    EtlPopupDesignParamComponent,
    EtlPopupDesignStaticParamComponent,
    EtlPopupDesignSelectTableGroupageComponent,
    EtlTaskPreviewComponent,
    EtlTaskComponent,
    EtlPopupDesignScriptsComponent,
    ListColEtlComponent,
    SimpleListColEtlComponent,
    SelectCampaignComponent,
    TableListHierarchyComponent,
    EtlExportUpdateComponent,
    EtlExportUpdateDescriptionComponent,
    EtlExportUpdateSearchComponent,
    EtlExportUpdateParamComponent];


@NgModule({
    imports: [
        // RouterModule.forChild(ENTITY_STATES),
        // DmpSharedLibsModule,
        ComponentsModule,
        MonacoEditorModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CommonModule,
        EtlDictionnaryModule,
        TableModule,
        InputNumberModule,
        StepsModule,
        ButtonModule,
        DropdownModule,
        DatePickerModule,
        DropdownModule,
        OverlayPanelModule,
        ChipsModule,
        FieldsetModule,
        ProgressSpinnerModule,
        DialogModule,
        ScrollPanelModule,
        TabViewModule,
        TabsModule,
        MessagesModule,
        MessageModule,
        BreadcrumbModule,
        PanelModule,
        ListboxModule,
        InputSwitchModule,
        TooltipModule,
        AutoCompleteModule,
        ToggleButtonModule,
        KeyFilterModule,
        MultiSelectModule,
        CheckboxModule,
        SplitButtonModule,
        // FileUploadModule,
        TextareaModule,
        ToastModule,
        RadioButtonModule,
        AccordionModule,

        SelectButtonModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        TranslateModule,
        TableModule,
        TableDataModule,

        FileUploadModule,
        MenuModule,
        EtlScriptUpdateComponent,
        SelectGroovyScriptComponent,
        PasswordModule,
        InputTextModule,
        InputGroupModule,
        FileServerConfigComponent,
        TableDataModule,
        BeautifulFilterComponent,
        ImportStepsComponent,
        SelectEtlsComponent,
        PipesModule,
        ProgressBarModule,
        EtlI18nConversionComponent
    ],
    declarations: [
        ...cmp
    ],
    exports: [
        ...cmp
    ],
    providers: [
        [{provide: TasksService, useValue: (window as any).tasksService}],
        ConfirmationService,
        MessageService
    ]
})
export class EtlModule {
}
